export default __webpack_public_path__ + "static/media/card-book-icon.78c874f0.png";